<app-vis-dialog title="訊息" [show]="isDialogOpened" (close)="onDialogClose(false)" [maxWidth]="'95vw'" [superWidth]="'95%'"
  i18n-title="@@DialogMessage">
  <div style="padding: 10px 15px;" class="extend-msg">
    <ng-content></ng-content>
  </div>
  <app-vis-dialog-actions>
    <button type="button" (click)="onDialogClose(true)" i18n="@@DialogClose">關閉</button>
  </app-vis-dialog-actions>
</app-vis-dialog>
